import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { ConsentService } from '@web-client/shared';

@Component({
    selector: 'lib-cookie-consent',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './cookie-consent.component.html',
    styleUrl: './cookie-consent.component.scss',
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(20px)' }),
                animate('400ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 1, transform: 'translateY(0)' })),
            ]),
            transition(':leave', [
                animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 0, transform: 'translateY(20px)' })),
            ]),
        ]),
    ],
})
export class CookieConsentComponent implements OnInit {
    private readonly consentService = inject(ConsentService);
    isVisible = false;

    ngOnInit(): void {
        // Subscribe to know if the banner should be shown
        this.consentService.requiresConsent$.subscribe((requires) => {
            if (requires && !this.isVisible) {
                // Delay to avoid layout shift and LCP interference
                setTimeout(() => {
                    // Double check status after delay in case it was granted manually in between
                    if (this.consentService.currentStatus === 'pending') {
                        this.isVisible = true;
                    }
                }, 1500);
            }
        });
    }



    onAccept(): void {
        this.consentService.grantConsent();
        this.isVisible = false;
    }

    onDecline(): void {
        this.consentService.denyConsent();
        this.isVisible = false;
    }
}
